export const LOGIN = 'login'

export const PRODUCTS = '/products'
export const PRODUCT_INFO = '/products/:id'
export const PRODUCT_UPDATE = '/products/:id'
export const PRODUCT_CREATE = '/products'
export const PRODUCT_DELETE = '/products/:id'
export const PRODUCT_STOCK_LOG = '/products/:id/stock_trackings'
export const PRODUCTS_DONWLOAD = '/products/list/csv'

export const MANUFACTURERS = '/manufacturers'
export const MANUFACTURER_UPDATE = '/manufacturers/:id'
export const MANUFACTURER_CREATE = '/manufacturers'

export const PRODUCT_CATEGORIES = '/product_categories'
export const PRODUCT_CATEGORIES_UPDATE = '/product_categories/:id'
export const PRODUCT_CATEGORIES_CREATE = '/product_categories'

export const PRODUCT_GROUPS = '/product_groups'
export const PRODUCT_GROUPS_UPDATE = '/product_groups/:id'
export const PRODUCT_GROUPS_CREATE = '/product_groups'

export const CUSTOMERS = '/customers'
export const CUSTOMERS_INFO = '/customers/:id'
export const CUSTOMERS_UPDATE = '/customers/:id'
export const CUSTOMERS_CREATE = '/customers'

export const SALES_CHANNELS = '/sales_channels'
export const SALES_CHANNELS_UPDATE = '/sales_channels/:id'
export const SALES_CHANNELS_CREATE = '/sales_channels'

export const ORDERS = '/orders'
export const ORDERS_CREATE = '/orders'
export const ORDERS_INFO = '/orders/:id'
export const ORDERS_CANCEL = '/orders/:id'

export const ADD_CART_ITEM = '/orders/:id/order_items'
export const REMOVE_CART_ITEM = '/orders/:orderId/order_items/:itemId'
export const UPDATE_CART_ITEM = '/orders/:orderId/order_items/:itemId'
export const CONFIRM_OUT_OF_STOCK = '/orders/:orderId/order_items/:itemId/confirm_out_of_stock'

export const CHECKOUT_CONFIRM_ORDER = '/checkout/order/:id'
export const CHECKOUT_CUSTOMER_PENDINGS = '/checkout/customer_pendings/:id'
export const CHECKOUT_REGISTER_PAYMENT = '/order_payments'
export const CHECKOUT_CANCEL_PAYMENT = '/order_payments/:id'
export const CHECKOUT_REOPEN_ORDER = '/checkout/reopen/order/:id'

export const PAYMENT_METHODS = '/payment_methods'
export const PAYMENT_METHODS_CREATE = '/payment_methods'
export const PAYMENT_METHODS_UPDATE = '/payment_methods/:id'
export const PAYMENT_METHOD_INFO = '/payment_methods/:id'
export const PAYMENT_METHODS_DESTROY = '/payment_methods/:id'

export const PAYMENT_PLANS_CREATE = '/payment_methods/:paymentMethodId/payment_plans'
export const PAYMENT_PLAN_UPDATE = '/payment_methods/:paymentMethodId/payment_plans/:id'
export const PAYMENT_PLAN_DESTROY = '/payment_methods/:paymentMethodId/payment_plans/:id'

export const PAYMENT_INFO = '/order_payments/:id'

export const STOCK_ACTIVITIES = '/stock_activities'
export const STOCK_ACTIVITY_CREATE = '/stock_activities'
export const STOCK_ACTIVITY_INFO = '/stock_activities/:id'

export const PRICES_SEARCH = '/prices/products/search'
export const PRICES_CALCULATE = '/prices/products/calculate'
export const PRICES_UPDATE = '/prices/products/update'

export const CART_GENERAL_DISCOUNT = '/cart/general/discount'

export const REPORT_SALES_DAILY = '/reports/sales/daily'
export const REPORT_PAYMENTS_DAILY = '/reports/payments/daily'
export const RECEIPTS_REPORT = '/reports/payments/range'

export const ANALYTICS_CUSTOMERS_GENERAL = '/analytics/customers/general'
export const ANALYTICS_CUSTOMERS_MONTH = '/analytics/customers/by_month'
export const ANALYTICS_CUSTOMERS_YEAR = '/analytics/customers/by_year'
